import { Link } from "react-router-dom";

const Form = ({ form }) => (
  <div className="ncs-form">{form.map((f, i) => <span key={i} className={f === "W" ? "win" : "loss"}>{f}</span>)}</div>
);

export function EuroTable({ comp, group, single }) {
  const title = single ? group.name.toUpperCase() : `GROUP ${group.name}`;
  return (
    <section className="ncs-panel" data-testid={`europe-group-${group.name.replace(/\s+/g, "-").toLowerCase()}`}>
      <h2><span className="ncs-east" />{title}</h2>
      <div className="ncs-scroll">
        <table>
          <thead><tr>{["#", "TEAM", "GP", "W", "L", "WIN%", "PF", "PA", "+/-", "HOME", "AWAY", "L10", "FORM"].map((h) => <th key={h} className={h === "TEAM" ? "ncs-team-col" : ""}>{h}</th>)}</tr></thead>
          <tbody>
            {group.rows.map((r) => (
              <tr key={r.code} data-testid={`europe-row-${r.code}`}>
                <td className="ncs-seed">{r.position}</td>
                <td className="ncs-team-col">
                  <Link to={`/europe/${comp}/teams/${r.code}`} data-testid={`europe-team-link-${r.code}`}>
                    {r.crest ? <img className="ncs-logo" src={r.crest} alt="" loading="lazy" /> : <span className="ncs-logo-fallback">{r.tv}</span>}
                    <span>{r.name}</span><span className="ncs-chevron">›</span>
                  </Link>
                </td>
                <td>{r.gp}</td><td>{r.w}</td><td>{r.l}</td><td>{r.pct}</td><td>{r.pf}</td><td>{r.pa}</td>
                <td className={String(r.diff).startsWith("-") ? "ncs-negative" : "ncs-positive"}>{r.diff}</td>
                <td>{r.home}</td><td>{r.away}</td><td>{r.last10}</td>
                <td><Form form={r.form} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
